//App.js
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { LoginPage } from "./pages/LoginPage";
import { DashboardPage } from "./pages/DashboardPage";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { AuthProvider, AuthContext } from "./context/AuthContext";
import { BackupsPage } from "./pages/BackupsPage";
import { UsersPage } from "./pages/UsersPage";
import { UsuarioBucketPage } from "./pages/UsuarioBucketPage";
import { FaturaPage } from "./pages/FaturaPage";
import { Header } from "./components/Header";
import { Sidebar } from "./components/Sidebar";
import { useContext, useState } from "react";

// Novo componente AppInner com o uso do contexto
const AppInner = () => {
  const { token, logout } = useContext(AuthContext);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <Router>
      {token && (
        <>
          <Header
            onLogout={logout}
            onToggleSidebar={() => setSidebarOpen((v) => !v)}
          />
          <Sidebar open={sidebarOpen} onClose={() => setSidebarOpen(false)} />
        </>
      )}
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route
          path="/usuario-bucket"
          element={
            <ProtectedRoute requiredPermission={[1]}>
              <UsuarioBucketPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dashboard"
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/backups"
          element={
            <ProtectedRoute>
              <BackupsPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/usuarios"
          element={
            <ProtectedRoute requiredPermission={[1, 2]}>
              <UsersPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/fatura"
          element={
            <ProtectedRoute>
              <FaturaPage />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Router>
  );
};

// Componente principal com AuthProvider
function App() {
  return (
    <AuthProvider>
      <AppInner />
    </AuthProvider>
  );
}

export default App;
